<template>
    <DCard
        :title="
            __('messages.dashboard.widgets.admin.title') + ' - ' + __('messages.dashboard.widgets.admin.description')"
        class="height p-3"
    >
        <DRow
            class="main-card p-3"
        >
            <DCol
                col="6"
            >
                <CronJobsData
                    :cronjob-data="cronjobData"
                />
            </DCol>
        </DRow>
    </DCard>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { route } from '~@/Composables/route'

import { __ } from '~@/Composables/translation'
import CronJobsData from './CronJobsData.vue'

const cronjobData = ref([])

onMounted(async () => {
    window.axios.get(route('widgets.get-data'), {
        params: {
            widget: 'admin'
        }
    })
        .then(response => {
            cronjobData.value = response.data.data.cronjobs
        })
})

</script>
<style>
.table th {
    border-top: 0;
}
.main-card {
    padding-top: 15px;
}
</style>
